import SortFacetController from './sort-facet.controller';
import { SortFacetProps } from './sort-facet.model';

const SortFacet: React.FC<SortFacetProps> = (props) => {
  return <SortFacetController {...props} />;
};

export default SortFacet;
